// Module
var code = "<div class=\"grid_division\"> <div class=\"main_grid\"> <div> <div class=\"mishion_history\"> <div class=\"mission_title\">Parts Inventory</div> </div> <div class=\"text-right\"> <a class=\"btn btn-secondary\" ui-sref=\"^.add\" if-has-permissions=\"'partAdd'\"> <span> <i class=\"fa fa-plus\"></i> ADD PART </span> </a> </div> <parts-main-grid> </parts-main-grid> </div> </div> </div>";
// Exports
var _module_exports = code;;
var path = 'parts/Pages/main/index.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;